import { render, staticRenderFns } from "./TrainList.vue?vue&type=template&id=00fefe8c&scoped=true"
import script from "./TrainList.vue?vue&type=script&lang=js"
export * from "./TrainList.vue?vue&type=script&lang=js"
import style0 from "./TrainList.vue?vue&type=style&index=0&id=00fefe8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fefe8c",
  null
  
)

export default component.exports